import styled from 'styled-components';

import { SearchField } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

export const StyledFormWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: flex-end;
    min-height: 52px;
`;

export const SearchWrapper = styled.div`
    align-items: center;
    display: flex;
    position: relative;
    width: 100%;
`;

export const SearchInput = styled(SearchField)`
    border-radius: 50px;
    margin-bottom: 0;
    width: 100%;
`;

export const StyledIconSearch = styled(IconManager)`
    left: 20px;
    position: absolute;
`;

export const StyledIconSearchButton = styled.button`
    background-color: transparent;
    border: none;
    margin-right: 18px;
    outline: none;
`;
